import { render, staticRenderFns } from "./StartToStudySection.vue?vue&type=template&id=cfbdecac&scoped=true&"
import script from "./StartToStudySection.vue?vue&type=script&lang=ts&"
export * from "./StartToStudySection.vue?vue&type=script&lang=ts&"
import style0 from "./StartToStudySection.vue?vue&type=style&index=0&id=cfbdecac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbdecac",
  null
  
)

export default component.exports